import initNavbarScroll from './global-templates/navigation-scroll';
import sectionTeam  from './template-parts/sections/section-team';

initNavbarScroll();
sectionTeam();
